import { Poi } from './poi';

export class ElencoPoi {
    elenco:     Array<Poi>;
    page:       number;
    size:       number;
    maximumPages:   number;
    pageSize:   number;
    totalElements:   number;
}

